module.exports = __webpack_public_path__ + "static/media/deleteicon.2575c617.svg";